import { Box, CircularProgress } from '@mui/material';
import { SidepanelFooter, SidepanelHeader, SidepanelLayout } from '../Sidepanel';
import FilterGroupsList from './FilterGroupsList';
import { useEffect, useState } from 'react';
import { FilterListItemMap } from './types';

interface AppAccessSidepanelProps {
  open: boolean;
  onClose: () => void;
  onSave: (selectedIds: string[]) => void;
  isViewOnly?: boolean;
  selectedFilters?: string[];
  title: string;
  subtitleLabel?: string;
  subtitle?: string;
  filterMap: FilterListItemMap;
  isLoading?: boolean;
}

export const AppAccessSidepanel = ({
  open,
  onClose,
  onSave,
  isViewOnly = false,
  selectedFilters,
  title,
  subtitleLabel,
  subtitle,
  filterMap,
  isLoading = false,
}: AppAccessSidepanelProps) => {
  const [selectedIds, setSelectedIds] = useState<string[]>([]);

  useEffect(() => {
    if (!open) return;
    setSelectedIds(selectedFilters ?? []);
  }, [open, selectedFilters]);

  const existingIds = Object.values(filterMap)
    .flat()
    .map((item) => item.value);

  const handleSave = () => {
    onSave(selectedIds);
    onClose();
  };

  return (
    <SidepanelLayout open={open} onClose={onClose}>
      <SidepanelHeader
        title={title}
        onClose={onClose}
        subtitleLabel={subtitleLabel ?? ''}
        subtitle={subtitle ?? ''}
      />

      {isLoading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
          <CircularProgress size={28} />
        </Box>
      ) : (
        <FilterGroupsList
          filterMap={filterMap}
          selectedIds={selectedIds}
          onSelectionChange={setSelectedIds}
          existingGameIds={existingIds}
          isViewOnly={isViewOnly}
        />
      )}

      <SidepanelFooter onSave={handleSave} onCancel={onClose} isSaveDisabled={isViewOnly} />
    </SidepanelLayout>
  );
};
